import { put, takeEvery } from "redux-saga/effects"
import { fetchGraphMethod, fetchMethod } from "../../services/httpService"
import messagePopup from "../../utils/messagePopup"

// ========================================== Action Type =====================================================
export const actionType = {
    PROFILE_SECTION_LIST_START: 'PROFILE_SECTION_LIST_START',
    PROFILE_SECTION_LIST_SUCCESS: 'PROFILE_SECTION_LIST_SUCCESS',
    PROFILE_SECTION_LIST_FAILED: 'PROFILE_SECTION_LIST_FAILED'
}

// ============================================ Actions ========================================================
export const profileSectionListStart = (data) => ({
   type: actionType.PROFILE_SECTION_LIST_START,
   payload: data
})

export const profileSectionListSuccess = (data) => ({
    type: actionType.PROFILE_SECTION_LIST_SUCCESS,
    payload: data
})

export const profileSectionListFailed = (data) => ({
    type: actionType.PROFILE_SECTION_LIST_FAILED,
    payload: data
})

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null
}

export default function profileSectionListReducer(state = INIT_STATE,action){
  switch(action.type){
      case actionType.PROFILE_SECTION_LIST_START: 
        return {
            ...state,
            loading: true
        }
      case actionType.PROFILE_SECTION_LIST_SUCCESS:
        return {
            ...state,
            loading: false,
            data: action.payload,
            error: null
        }  
      case actionType.PROFILE_SECTION_LIST_FAILED:
        return {
            ...state,
            loading: false,
            data: null,
            error: action.payload
        }       
      default: return {...state}  
  }
} 

// ===================================================== side effect =============================================

export function* profileSectionListSaga(action){
   try {
    const response = yield fetchGraphMethod(action.payload.query,action.payload.variables,true);
    if(response && response.status === 200){
       const allAthletesports = response.data.data ? response.data.data : null
       yield put(profileSectionListSuccess(allAthletesports));
    } else {
      messagePopup('','Sports List failed','error')   
      yield put(profileSectionListFailed('Sports List failed')) 
    }
   } catch (error) {
     messagePopup('','Sports List failed','error')   
     yield put(profileSectionListFailed('Sports List failed')) 
   }
}

export function* watchProfileSectionListSaga(){
    yield takeEvery(actionType.PROFILE_SECTION_LIST_START, profileSectionListSaga)
}